var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FFCC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.3065C7 11.5853 7.56862 11 8.26923 11H30.2692C30.9698 11 31.5385 11.5853 31.5385 12.3065C31.5385 13.0276 30.9698 13.6129 30.2692 13.6129H8.26923C7.56862 13.6129 7 13.0276 7 12.3065ZM38.7308 23.1935H8.26923C7.56862 23.1935 7 23.7788 7 24.5C7 25.2212 7.56862 25.8065 8.26923 25.8065H38.7308C39.4314 25.8065 40 25.2212 40 24.5C40 23.7788 39.4314 23.1935 38.7308 23.1935ZM23.5 35.3871H8.26923C7.56862 35.3871 7 35.9724 7 36.6935C7 37.4147 7.56862 38 8.26923 38H23.5C24.2006 38 24.7692 37.4147 24.7692 36.6935C24.7692 35.9724 24.2006 35.3871 23.5 35.3871Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconAdmin);
export default __webpack_public_path__ + "static/media/menu-icon-admin.7234b80b88def8f3861f1fabc93ab36d.svg";
export { ForwardRef as ReactComponent };